import { Component, OnInit } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { environment } from '../../../environments/environment';
import { MenuService } from '../../providers/menu.service';
import { trigger, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css'],
  animations: [
    trigger('fadeInOut', [
      transition('* => *', [
        style({ opacity: 0 }),
        animate(500, style({ opacity: 1 }))
      ]),
      transition('* => *', [
        animate(500, style({ opacity: 0 }))
      ])
    ])
  ],
})

export class NavigationComponent implements OnInit {
  language: string;
  menu: any = {};
  languageSwitcher: any = {};
  objectKeys = Object.keys;
  path: string;
  menuShown: boolean = false;
  routeParams: any = {};

  constructor(private router: Router, private menuService: MenuService) { }

  buildRouteParams(routesRecognized: RoutesRecognized) {
    let paramsKey = {};
    let splittedPath = this.path.split('/');
    splittedPath.forEach((value: string, idx: number, arr: Array<string>) => {
      // Checking if the chunk is starting with ':', if yes, we suppose it's a parameter
      if (value.indexOf(':') === 0) {
        // Attributing the parameter at the index where it is found in the path
        paramsKey[idx] = value;
      }
    });
    this.routeParams = {};
    let splittedUrl = routesRecognized.url.split('/');
    /**
     * Removing empty chunk or the url,
     * because we're splitting the string with '/', and the url starts with a '/')
     */
    splittedUrl = splittedUrl.filter(n => n !== "");
    for (let idx in paramsKey) {
      this.routeParams[paramsKey[idx]] = splittedUrl[idx];
    }
    this.language = this.routeParams[':language'];
    if (!this.language) {
      this.language = routesRecognized.state.root['_routerState']['_root'].children[0].value['_routeConfig'].data.defaultLanguage;
    }
    for (let language in environment.allowedLanguages) {
      this.languageSwitcher[language] = {
        label: environment.allowedLanguages[language],
        params: Object.assign({}, this.routeParams),
      };
      if (this.languageSwitcher[language].params[':language']) {
        this.languageSwitcher[language].params[':language'] = language;
      }
      this.languageSwitcher[language]['link'] = this.buildRoutePath(this.languageSwitcher[language].params);
    }
    this.getMenu();
  }

  ngOnInit() {
    this.router.events.subscribe(routesRecognized => {
      if (routesRecognized instanceof RoutesRecognized) {
        this.path = routesRecognized.state.root['_routerState']['_root'].children[0].value['_routeConfig'].path;
        this.buildRouteParams(routesRecognized);
      }
    });
  }

  getMenu() {
    this.menuService.getMenu(this.language).then((menu) => {
      this.menu = menu;
    }, (error) => {
      console.log(error);
    });
  }

  buildRoutePath(params: any): string {
    if (this.path) {
      let newPath = this.path;
      for (let key in params) {
        newPath = newPath.replace(key, params[key]);
      }
      return '/' + newPath;
    }

    return null;
  }

  languageChange(value) {
    this.router.navigate([value]);
  }

  showMenu() {
    this.menuShown = !this.menuShown;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/navigation/navigation.component.ts